import { ReactElement } from "react";

import { Popover, Portal } from "@chakra-ui/react";

import { RadioSelectList } from "../radio-select-list";
import { RadioOptionType } from "../radio-select-list/types";

import { EditableRadioToggle } from "./editable-radio-toggle";

type EditableRadioProps<T extends string> = {
  name: string;
  placement?: "top-start" | "top-end" | "bottom-start" | "bottom-end";
  value?: T | null;
  options?: RadioOptionType<T>[];
  allowUnselect?: boolean;
  toggleIcon?: ReactElement;

  onChangeValue?: (value: T) => void;
};

export const EditableRadio = <T extends string>({
  placement = "bottom-start",
  name,
  value,
  options = [],
  allowUnselect = false,
  onChangeValue,
  toggleIcon,
}: EditableRadioProps<T>) => {
  const selectedOption = options.find(option => value === option.value);

  return (
    <Popover.Root
      lazyMount
      unmountOnExit
      positioning={{ placement, offset: { crossAxis: 0, mainAxis: 8 } }}
    >
      <Popover.Trigger asChild>
        <EditableRadioToggle selectedOption={selectedOption} icon={toggleIcon} />
      </Popover.Trigger>
      <Portal>
        <Popover.Positioner>
          <Popover.Content>
            <RadioSelectList
              name={name}
              value={value}
              options={options}
              onChangeValue={onChangeValue}
              allowUnselect={allowUnselect}
            />
          </Popover.Content>
        </Popover.Positioner>
      </Portal>
    </Popover.Root>
  );
};
